<template>
  <figure>
    <img class="light" src="../assets/images/SOCLogoLight.png"/>
  </figure>
</template>

<script setup lang="ts">
</script>
